const Traffic = () => {
  return (
    <>
      <h1>Traffic</h1>
    </>
  );
};

export default Traffic;
